import type { useUser } from "@clerk/react";

import { updateMyOrgMemberAvatar } from "../../orgMembers";
import { LOCAL_SELF_MEMBER_ID } from "../workspace/morrowUserProfileStore";
import { upsertTeamMember } from "../workspace/morrowTeamStore";
import {
  getUserProfile,
  metadataFromUserProfile,
  writeUserProfile,
} from "../workspace/morrowUserProfileStore";

type ClerkUser = NonNullable<ReturnType<typeof useUser>["user"]>;

/** Persist a DiceBear seed across local profile, Clerk metadata, and org directory. */
export async function saveMorrowUserAvatarSeed(input: {
  readonly user: ClerkUser;
  readonly userId: string | null;
  readonly displayName: string;
  readonly avatarSeed: string;
}): Promise<void> {
  const current = getUserProfile();
  const profile = writeUserProfile({
    title: current.title,
    role: current.role,
    avatarSeed: input.avatarSeed,
    portraitImageUrl: "",
  });
  upsertTeamMember({
    id: input.userId ?? LOCAL_SELF_MEMBER_ID,
    name: input.displayName,
    title: profile.title,
    role: profile.role,
    avatarSeed: profile.avatarSeed,
  });
  await input.user.update({
    unsafeMetadata: metadataFromUserProfile({ ...input.user.unsafeMetadata }, profile),
  });
  await updateMyOrgMemberAvatar(profile.avatarSeed);
}
